<c11n-radio-group id="productType" groupId="productType" errorText="Please choose one." hideLegend="false"
                  legendText="{{fd3ContentFiltersListResponse['product']}}" hasError="true" variant="default" hasCustomHintError="false" (stateChange)="onViewProductsChange($event)">
    <div class="storybook-horizontal-radios">
        <c11n-radio [labelText]=filter.assetCaas.allFunds state="checked">
            <input c11nRadioInput id="allFunds" type="radio" name="viewProducts" [value]=filter.assetCaas.allFunds
                   [checked]=!isAllProductSelected />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.mutualFunds >
            <input c11nRadioInput id="{{filter.productType.mf.id}}" type="radio" name="viewProducts" [value]=filter.assetCaas.mutualFunds
                   [checked]=filter.productType.mf.value />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.etf>
            <input c11nRadioInput id="{{filter.productType.etf.id}}" type="radio" name="viewProducts" [value]=filter.assetCaas.etf
                   [checked]=filter.productType.etf.value />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.trusts>
            <input c11nRadioInput id="{{filter.productType.colTrust.id}}" type="radio" name="viewProducts"
                   [value]=filter.assetCaas.trusts [checked]=filter.productType.colTrust.value />
        </c11n-radio>
    </div>
</c11n-radio-group>
